import { render, staticRenderFns } from "./LoyaltyPoints.vue?vue&type=template&id=fbc2943c&"
import script from "./LoyaltyPoints.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPoints.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyPoints.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports